import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=8dd136bc&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dd136bc')) {
      api.createRecord('8dd136bc', component.options)
    } else {
      api.reload('8dd136bc', component.options)
    }
    module.hot.accept("./Access.vue?vue&type=template&id=8dd136bc&", function () {
      api.rerender('8dd136bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/Access.vue"
export default component.exports